import src from "IMAGE";
export default { src, width: 876, height: 1074, blurWidth: 0, blurHeight: 0};
